define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var lpUtils = require('utils/lpUtils');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var WidgetViewController = require('web-agent-framework/WidgetViewController');

    /**
     * This is for the UMS token privider, we must pass an "invite" id in order to generate the OTK, and it's must be a valid uuid (GUID).
     * @type {string}
     */
    var DUMMY_PCI_TOKEN = '00000000-0000-0000-0000-000000000000';
    var TOKENIZER_DOMAIN_KEY = '{tokenizer}';
    var LOADING_TIMEOUT = 1000 * 30; // 30SEC
    var PCI_RESULTS_PAGE = '/pcigw/pci_dynamic_results_le.jsp';
    var PCI_STATUS_RESPONSES = {
        OK: 'ok',
        ERROR: 'error'
    };
    var LP_REF_MAKER = 'lp_ref:';
    var applicationType = 'PCIDataWidget';
    var logger = WebAgentLogger.getLogger(applicationType);

    var PCIDataWidget = WidgetViewController.extend({
        controllerName: applicationType,
        applicationType: applicationType,
        templateFile: "LP_PCIDataWidget.html",
        singleton: false,
        span: 1,
        LPViewMap: {
            wrapper: '.lpview_secure_forms_widget_container',
            stateWrapper: '.lpview_state_placeholder',
            iFrame: '.lpview_iframe_placeholder',
            refreshAction: '.lpview_refresh_action',
            displayAction: '.lpview_secure_forms_init_state_display_button',
            secureFormHeader: '.lpview_secure_form_header',
            secureFormBody: '.lpview_secure_form_body',
            secureFormTitle: '.lpview_secure_form_title',
            initStateFormName: '.lpview_secure_forms_init_state_text_form_name'
        },
        LPStateMaps: {
            init: 'init',
            loading: 'loading',
            error: 'error',
            success: 'success'
        },
        initialize: function (constructorData) {
            logger.info('initializing Secure form widget.');

            // Adding Run-Time protection.
            if(!lpTag.WebAgent.logicController.hasPCIDataWidgetSupport()){
                return;
            }

            this.secureFormUniqueId = null;
            this.modelController = constructorData.modelController;
            this.visitorId = constructorData.visitorId;
            this.tokenServerDomain = _getSourceOrigin();
            this.iframeElement = this.getFirstElement(this.LPViewMap.iFrame, this);
            this.onDisplayResolved = constructorData.onDisplayResolved;
            this.onIFrameLoaded = _onIFrameLoaded.bind(this);
            this.onIFrameError = _onIFrameError.bind(this);
            this.onIFrameTimeOut = _onIFrameTimeOut.bind(this);

            this.setVisibility(false);
        },
        events: function () {
        },
        render: function () {
        }
    });

    PCIDataWidget.applicationType = applicationType;

    PCIDataWidget.prototype.setVisibility = function (toggleValue) {
        var hidden = !this.hidden;
        if (typeof toggleValue === 'undefined') {
            hidden = !toggleValue;
        }

        this.hidden = hidden;
        if (hidden) {
            this.hideWidget();
        } else {
            this.showWidget();
        }
    };
    PCIDataWidget.prototype.bindEvents = function () {
        this.bindModel({
            modelPath: 'participants.info.' + this.visitorId + '.data.participant.customerInfo.userName',
            callback: this.onUUIDSDEChange
        });

        this.bindViewEvent({
            selector: this.LPViewMap.refreshAction,
            DOMEvent: "click",
            callback: this.initIFrameView
        });
        this.bindViewEvent({
            selector: this.LPViewMap.displayAction,
            DOMEvent: "click",
            callback: this.initIFrameView
        });
    };
    PCIDataWidget.prototype.unbindEvents = function () {
        this.unbindModel({
            modelPath: 'participants.info.' + this.visitorId + '.data.participant.customerInfo.userName',
            callback: this.onUUIDSDEChange
        });

        this.unbindViewEvent({
            selector: this.LPViewMap.refreshAction,
            DOMEvent: "click",
            callback: this.initIFrameView
        });

        this.unbindViewEvent({
            selector: this.LPViewMap.displayAction,
            DOMEvent: "click",
            callback: this.initIFrameView
        });
    };


    /**
     * handle the change of value in the Customer ID - holding the UUID for the secure form.
     * @param data - lpModel data change event.
     */
    PCIDataWidget.prototype.onUUIDSDEChange = function (data) {
        if (this.chatId && data && data.newValue) {
            var uuid = extractUUID(data.newValue);
            if (uuid && (this.secureFormUniqueId != uuid)) {
                this.secureFormUniqueId = uuid;
                this.initIFrameView();
            }
        }

        /**
         * the data come to us as SDE, we need to remove the marker and get the data.
         * ex: lp_ref:95e75c73-8c30-4904-8bbb-703598b1919c
         * @param sdeData
         */
        function extractUUID(sdeData) {
            if (sdeData.indexOf(LP_REF_MAKER) === 0) {
                return sdeData.slice(LP_REF_MAKER.length);
            }
        }
    };
    PCIDataWidget.prototype.onChatIdChanged = function (data) {
        var chatId = this.getFirstProperty(data.newValue);
        if (chatId && this.chatId !== chatId) { // split session support
            this.unbindEvents();
            this.chatId = chatId;
            this.bindEvents();
        }
    };

    PCIDataWidget.prototype.setBindings = function () {
        this.bindViewEvent({view: window, DOMEvent: "message", callback: this.onPostMessageReceived});
        lpUtils.addEventListener(this.iframeElement, 'load', this.onIFrameLoaded);
        lpUtils.addEventListener(this.iframeElement, 'error', this.onIFrameError);
    };

    PCIDataWidget.prototype.removeBindings = function () {
        lpUtils.removeEventListener(this.iframeElement, 'load', this.onIFrameLoaded);
        lpUtils.removeEventListener(this.iframeElement, 'error', this.onIFrameError);
        this.removeTimeout();
        this.unbindViewEvent({view: window, DOMEvent: "message", callback: this.onPostMessageReceived});
    };
    PCIDataWidget.prototype.removeTimeout = function () {
        if (this.iframeLoadingTimeout) {
            clearTimeout(this.iframeLoadingTimeout);
            this.iframeLoadingTimeout = null;
        }
    };
    PCIDataWidget.prototype.setState = function (state, infoMessage) {
        var wrapper = this.getFirstElement(this.LPViewMap.wrapper);
        var stateClasses = [this.LPStateMaps.success, this.LPStateMaps.loading, this.LPStateMaps.error, this.LPStateMaps.init];
        var stateIndex = stateClasses.indexOf(state);
        if (stateIndex >= 0) {
            stateClasses.splice(stateIndex, 1);
        }
        this.removeClass(wrapper, stateClasses);
        this.addClass(wrapper, state);

        logger.debug('secure forms widget: new state->' + state + ' info: ' + infoMessage);

    };
    PCIDataWidget.prototype.onPostMessageReceived = function (e) {
        if (e.source === this.iframeElement.contentWindow && e.origin === this.tokenServerDomain) {
            this.removeBindings();
            try {
                var msg = JSON.parse(e.data);
                if (msg.state === PCI_STATUS_RESPONSES.OK) {
                    this.unbindEvents();
                    this.setState(this.LPStateMaps.success);
                } else {
                    this.setState(this.LPStateMaps.error, 'PCI GW return error.');
                }
            } catch (ex) {
                this.setState(this.LPStateMaps.error, 'PCI GW data internal error.');
            }
        }
    };
    PCIDataWidget.prototype.initIFrameView = function () {
        var self = this;

        if (!lpTag.WebAgent.logicController.hasSecureFormsViewPermission()) {
            this.setState(this.LPStateMaps.error);
            return;
        }
        if (!this.tokenServerDomain) {
            logger.error('cannot get pci domain from csds.');
            this.setState(this.LPStateMaps.error);
            return;
        }

        var engagementType = lpTag.WebAgent.logicController.getEngagementTypeByVisitorId(this.visitorId);
        var siteId = this.modelController.getModelParam('account');
        var formUuid = this.secureFormUniqueId;
        var chatSessionId = this.modelController.getModelParam('chats.' + this.chatId + '.chatInfo.chatSessionId');
        var isActiveEngagement = (lpTag.WebAgent.logicController.getEngagementStateByChatId(this.chatId) === lpTag.WebAgent.logicController.engagementStates.active);
        var isMyChat = lpTag.WebAgent.logicController.isMyChat(this.chatId);

        if (isActiveEngagement && isMyChat) {
            this.setVisibility(true);
            this.setState(this.LPStateMaps.loading);

            if(engagementType === lpTag.WebAgent.logicController.engagementTypes.realTimeChat){
                lpTag.WebAgent.secureFormsController.requestOTK({
                    chatId: this.chatId,
                    uuid: formUuid,
                    success: onRealTimeOTKSuccess,
                    error: onOTKError
                });
            } else if(engagementType === lpTag.WebAgent.logicController.engagementTypes.asyncMessaging){
                lpTag.WebAgent.secureFormsController.requestMessagingOTK({
                    dialogId: this.chatId,
                    submissionId: formUuid,
                    invitationId: DUMMY_PCI_TOKEN,
                    success: onMessagingOTKSuccess,
                    error: onOTKError
                });
            }
        } else {
            // Not Allowed.
            this.unbindEvents();
        }

        function onRealTimeOTKSuccess(data){
            var urlParams = {
                siteid: siteId,
                otk: data.otk,
                token: formUuid,
                otkJson: JSON.stringify({
                    siteId: siteId,
                    chatId: chatSessionId
                })
            };

            var url = getFullIframeURI(self.tokenServerDomain + PCI_RESULTS_PAGE, urlParams);
            self.setIFrame(url);
        }

        function onMessagingOTKSuccess(data){
            var urlParams = {
                siteid: siteId,
                otk: data.token.readOtk,
                token: formUuid,
                otkJson: siteId + ':' + DUMMY_PCI_TOKEN
            };

            var url = getFullIframeURI(self.tokenServerDomain + PCI_RESULTS_PAGE, urlParams);
            self.setIFrame(url);
        }

        function onOTKError(err){
            self.setState(self.LPStateMaps.error, 'request otk failed.', err);
        }

        function getFullIframeURI(url, params) {
            var paramsStr = "";
            for (var key in params) {
                if (params.hasOwnProperty(key)) {
                    if (paramsStr !== "") {
                        paramsStr += "&";
                    }
                    paramsStr += key + "=" + encodeURIComponent(params[key]);
                }
            }
            return url + "?" + paramsStr;
        }

    };
    PCIDataWidget.prototype.setIFrame = function (url) {
        // setting the loading state.
        this.setState(this.LPStateMaps.loading);
        this.setBindings();

        // setting the 'SRC' attribute for the iframe element to trigger the loading.
        this.iframeElement.setAttribute('src', url);
        this.removeTimeout();
        this.iframeLoadingTimeout = setTimeout(this.onIFrameTimeOut, LOADING_TIMEOUT);
    };
    PCIDataWidget.prototype.dispose = function () {
        // tear down, remove the bubble and dispose resources.
        this.unbindEvents();
    };


    function _onIFrameLoaded() {
        this.setState(this.LPStateMaps.success);
        this.removeTimeout();
    }

    function _onIFrameError() {
        this.setState(this.LPStateMaps.error, 'error when loading the IFrame.');
        this.removeTimeout();
    }

    function _onIFrameTimeOut() {
        this.setState(this.LPStateMaps.error, 'IFrame loading timed out.');
        this.iframeLoadingTimeout = null;

        // removing the listener to remove the response of the IFrame.
        // resetting the IFrame src.
        this.removeBindings();
        this.iframeElement.setAttribute('src', 'about:blank');
    }

    function _getSourceOrigin() {
        return agentLEManager.getLEUrlResolverGetUrl(TOKENIZER_DOMAIN_KEY).toLowerCase();
    }

    return PCIDataWidget;

});
